import classNames from 'classnames';
import { FC } from 'react';

import { ReactComponent as FilterBubble } from '../../../../../assets/images/filter-bubble.svg';
import { ReactComponent as FilterIcon } from '../../../../../assets/images/filter-icon.svg';

const ItemFilter: FC<{ name: string; value?: number }> = ({ name, value }) => {
    if (name) {
        return (
            <div className={classNames('filter-item')} key={name}>
                <FilterIcon />
                {name}
                {/* <FilterBubble className="filter-item__bubble" /> */}
                {!!value && <FilterBubble className="filter-item__bubble" />}
                {/* <FilterBubble className="filter-item__bubble" /> */}
                <span
                    className={classNames('filter-item__bubble__text', {
                        'filter-item__bubble__text--wider': value && value > 9 && value < 100,
                    })}
                >
                    {!!value && `${value}`}
                </span>
            </div>
        );
    }

    return null;
};

export default ItemFilter;
